/* DivaniClick - anteprima colore live (prototipo).
   Ricolora le foto del prodotto in base al colore tessuto e alla finitura gambe scelti.
   Maschere: assets/dc-prev-<handle>-<n>.png (canale R = tessuto, canale G = gambe), una per foto n. */
(function () {
  var cfgEl = document.getElementById('dc-preview-config');
  if (!cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var medias = [];
  var swatchCache = {};
  var pending = false;
  var touched = false; /* ricolora solo dopo una scelta del cliente: all'apertura si vede la foto reale */

  function loadImg(src) {
    return new Promise(function (res, rej) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = rej; im.src = src; });
  }
  function rgb2hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255; var M = Math.max(r, g, b), m = Math.min(r, g, b), h = 0, s = 0, l = (M + m) / 2;
    if (M !== m) { var d = M - m; s = l > .5 ? d / (2 - M - m) : d / (M + m);
      if (M === r) h = (g - b) / d + (g < b ? 6 : 0); else if (M === g) h = (b - r) / d + 2; else h = (r - g) / d + 4; h /= 6; }
    return [h, s, l];
  }
  function hue2rgb(p, q, t) { if (t < 0) t += 1; if (t > 1) t -= 1; if (t < 1 / 6) return p + (q - p) * 6 * t; if (t < .5) return q; if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6; return p; }
  function hsl2rgb(h, s, l) { if (s === 0) { return [l * 255, l * 255, l * 255]; } var q = l < .5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q; return [hue2rgb(p, q, h + 1 / 3) * 255, hue2rgb(p, q, h) * 255, hue2rgb(p, q, h - 1 / 3) * 255]; }
  function hexToRgb(hex) { var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if (!m) return null; var n = parseInt(m[1], 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }

  function averageColor(url) {
    if (swatchCache[url]) return swatchCache[url];
    swatchCache[url] = loadImg(url).then(function (im) {
      var c = document.createElement('canvas'); c.width = 32; c.height = 32; var x = c.getContext('2d'); x.drawImage(im, 0, 0, 32, 32);
      var d = x.getImageData(0, 0, 32, 32).data, r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < d.length; i += 4) { if (d[i + 3] < 200) continue; if (d[i] > 245 && d[i + 1] > 245 && d[i + 2] > 245) continue; r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      return n ? [r / n, g / n, b / n] : null;
    }).catch(function () { return null; });
    return swatchCache[url];
  }

  function selectedFabricUrl() {
    var inp = document.querySelector('input[type="radio"][data-option-name="Colore"]:checked');
    if (!inp) return null;
    var lab = inp.closest('label') || (inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null);
    var sw = lab ? lab.querySelector('[style*="swatch-background"]') : null;
    var st = sw ? sw.getAttribute('style') : '';
    var m = /url\((['"]?)([^'")]+)\1\)/.exec(st || '');
    return m ? m[2] : null;
  }
  /* tinte usate SOLO per l'anteprima quando il colore del metaoggetto rende male in foto (es. ruggine troppo acceso) */
  var LEG_OVERRIDES = { 'ruggine': '#6e3418' };
  function selectedLegHex() {
    var b = document.querySelector('.leg-color-swatch.is-selected, .leg-color-swatch[aria-pressed="true"]');
    if (!b) return null;
    var handle = (b.getAttribute('data-leg-color') || '').toLowerCase();
    return LEG_OVERRIDES[handle] || b.getAttribute('data-color');
  }

  /* tavolozza della finitura: 64 colori dell'immagine del campione ordinati per luminosita' (26/10/2026) */
  var legPalCache = {};
  function selectedLegPalette() {
    var b = document.querySelector('.leg-color-swatch.is-selected, .leg-color-swatch[aria-pressed="true"]');
    var u = b ? b.getAttribute('data-img') : '';
    if (!u) return Promise.resolve(null);
    if (legPalCache[u]) return legPalCache[u];
    legPalCache[u] = loadImg(u).then(function (im) {
      var c = document.createElement('canvas'); c.width = 64; c.height = 64; var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, 64, 64);
      var d = x.getImageData(0, 0, 64, 64).data, px = [];
      for (var i = 0; i < d.length; i += 4) px.push([d[i], d[i + 1], d[i + 2], 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]]);
      px.sort(function (a, b) { return a[3] - b[3]; }); var P = [];
      for (var k = 0; k < 64; k++) { var a = Math.floor(k * px.length / 64), e = Math.max(a + 1, Math.floor((k + 1) * px.length / 64)), r = 0, g = 0, bb = 0; for (var j = a; j < e; j++) { r += px[j][0]; g += px[j][1]; bb += px[j][2]; } P.push([r / (e - a), g / (e - a), bb / (e - a)]); }
      P.id = u; return P;
    }).catch(function () { return null; });
    return legPalCache[u];
  }
  function prepare(media) {
    return Promise.all([loadImg(media.base), loadImg(media.mask)]).then(function (ims) {
      var im = ims[0], mk = ims[1];
      var w = 800, h = Math.round(800 * im.naturalHeight / im.naturalWidth);
      var c = document.createElement('canvas'); c.width = w; c.height = h; var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(im, 0, 0, w, h); var src = x.getImageData(0, 0, w, h);
      var mc = document.createElement('canvas'); mc.width = w; mc.height = h; var mx = mc.getContext('2d', { willReadFrequently: true });
      mx.drawImage(mk, 0, 0, w, h); var md = mx.getImageData(0, 0, w, h).data;
      var n = w * h, lum = new Float32Array(n), fab = new Float32Array(n), legs = new Float32Array(n), sf = 0, nf = 0, sl = 0, nl = 0;
      var d = src.data;
      for (var i = 0, p = 0; i < n; i++, p += 4) {
        var hsl = rgb2hsl(d[p], d[p + 1], d[p + 2]); lum[i] = hsl[2];
        var f = md[p] / 255, g = md[p + 1] / 255; fab[i] = f; legs[i] = g;
        if (f > .5) { sf += hsl[2]; nf++; } if (g > .5) { sl += hsl[2]; nl++; }
      }
      media.w = w; media.h = h; media.src = src; media.lum = lum; media.fab = fab; media.legs = legs;
      media.meanFab = nf ? sf / nf : .5; media.meanLegs = nl ? sl / nl : .2;
      var ll = []; for (var q2 = 0; q2 < n; q2++) if (legs[q2] > .5) ll.push(lum[q2]); ll.sort(function (a, b) { return a - b; });
      media.legLo = ll.length ? ll[Math.floor(ll.length * .05)] : 0; media.legHi = ll.length ? ll[Math.floor(ll.length * .97)] : 1;
      media.canvas = c; media.ctx = x; media.ready = true;
    });
  }

  function render(media, fabRgb, legRgb, legPal) {
    var d = media.src.data, out = media.ctx.createImageData(media.w, media.h), o = out.data, n = media.w * media.h;
    var fh = fabRgb ? rgb2hsl(fabRgb[0], fabRgb[1], fabRgb[2]) : null, lh = legRgb ? rgb2hsl(legRgb[0], legRgb[1], legRgb[2]) : null;
    for (var i = 0, p = 0; i < n; i++, p += 4) {
      var r = d[p], g = d[p + 1], b = d[p + 2], a;
      if (fh && (a = media.fab[i]) > 0) {
        var l = Math.max(0, Math.min(1, fh[2] + (media.lum[i] - media.meanFab) * 0.9));
        var c = hsl2rgb(fh[0], fh[1], l); r = r * (1 - a) + c[0] * a; g = g * (1 - a) + c[1] * a; b = b * (1 - a) + c[2] * a;
      }
      if (legPal && (a = media.legs[i]) > 0) {
        var lp = media.lum[i], hi = media.legHi, lo = media.legLo, sp = Math.max(.03, hi - lo);
        if (lp > hi) a *= Math.max(0, Math.min(1, (hi + .16 - lp) / .16));
        if (a > 0) { var tt = lp > hi ? .5 : .2 + .6 * Math.max(0, Math.min(1, (lp - lo) / sp)), cp = legPal[Math.min(63, Math.round(tt * 63))], ss = .82 + .36 * tt;
          r = r * (1 - a) + Math.min(255, cp[0] * ss) * a; g = g * (1 - a) + Math.min(255, cp[1] * ss) * a; b = b * (1 - a) + Math.min(255, cp[2] * ss) * a; }
      } else if (lh && (a = media.legs[i]) > 0) {
        var l2 = Math.max(0, Math.min(1, lh[2] + (media.lum[i] - media.meanLegs) * 0.8));
        var c2 = hsl2rgb(lh[0], lh[1], l2); r = r * (1 - a) + c2[0] * a; g = g * (1 - a) + c2[1] * a; b = b * (1 - a) + c2[2] * a;
      }
      o[p] = r; o[p + 1] = g; o[p + 2] = b; o[p + 3] = 255;
    }
    media.ctx.putImageData(out, 0, 0);
  }

  function overlaysFor(media) {
    var imgs = document.querySelectorAll('img.product-media__image');
    var list = [];
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i], s = (im.currentSrc || im.getAttribute('src') || '') + ' ' + (im.getAttribute('srcset') || '');
      if (s.indexOf(media.file) === -1) continue;
      var parent = im.parentElement; if (!parent) continue;
      var cv = parent.querySelector('canvas.dc-preview-canvas');
      if (!cv) {
        cv = document.createElement('canvas'); cv.className = 'dc-preview-canvas'; cv.width = media.w; cv.height = media.h;
        var cs = getComputedStyle(im);
        cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;object-fit:' + (cs.objectFit || 'contain') + ';object-position:' + (cs.objectPosition || '50% 50%') + ';';
        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
        parent.appendChild(cv);
      }
      list.push(cv);
    }
    return list;
  }

  function blit(media) {
    var cvs = overlaysFor(media);
    for (var i = 0; i < cvs.length; i++) { var cx = cvs[i].getContext('2d'); cx.clearRect(0, 0, cvs[i].width, cvs[i].height); cx.drawImage(media.canvas, 0, 0); }
  }

  function update() {
    if (pending) return; pending = true;
    setTimeout(function () {
      pending = false;
      var url = selectedFabricUrl(), legHex = selectedLegHex();
      Promise.all([url ? averageColor(url) : Promise.resolve(null), selectedLegPalette()]).then(function (res) { var fabRgb = res[0], legPal = res[1];
        var legRgb = hexToRgb(legHex);
        var key = (fabRgb ? fabRgb.join(',') : '-') + '|' + (legPal ? legPal.id : (legRgb ? legRgb.join(',') : '-'));
        medias.forEach(function (m) {
          if (!m.ready) return;
          if (m.key !== key) { render(m, fabRgb, legRgb, legPal); m.key = key; }
          blit(m);
        });
        var note = document.querySelector('.dc-preview-note');
        if (!note) { var gal = document.querySelector('media-gallery'); if (gal) { note = document.createElement('p'); note.className = 'dc-preview-note'; note.textContent = /^en/i.test(document.documentElement.lang || '') ? 'Indicative preview of fabric and leg colours. To see the fabrics in person, order the sample kit.' : 'Anteprima indicativa dei colori di tessuto e gambe. Per vedere i tessuti dal vivo ordina il kit campioni.'; note.style.cssText = 'font-size:.78rem;opacity:.7;margin:.5rem 0 0;' + (window.innerWidth < 750 ? 'padding:0 1rem;' : ''); gal.appendChild(note); } }
      });
    }, 0);
  }

  cfg.media.forEach(function (m, idx) {
    var media = { file: m.file, base: m.base, mask: cfg.assetBase.replace('-1.png', '-' + (idx + 1) + '.png'), ready: false };
    medias.push(media);
    prepare(media).then(function () { if (touched) update(); }).catch(function () { media.ready = false; });
  });

  document.addEventListener('change', function (e) { var t = e.target; if (t && t.matches && t.matches('input[type="radio"][data-option-name="Colore"], input[type="radio"][data-option-name="Collezione tessuto"]')) { touched = true; update(); } }, true);
  document.addEventListener('click', function (e) { var t = e.target && e.target.closest ? e.target.closest('.leg-color-swatch') : null; if (t) { touched = true; setTimeout(update, 30); } }, true);
  /* la galleria viene ricostruita dal tema a ogni cambio variante: se le tele spariscono, le rimettiamo */
  if (window.MutationObserver) {
    var moTimer = null;
    new MutationObserver(function () {
      if (moTimer) return;
      moTimer = requestAnimationFrame(function () {
        moTimer = null;
        var missing = 0, imgs = document.querySelectorAll('img.product-media__image');
        for (var i = 0; i < imgs.length; i++) { var s = (imgs[i].currentSrc || imgs[i].getAttribute('src') || '') + ' ' + (imgs[i].getAttribute('srcset') || '');
          for (var k = 0; k < medias.length; k++) { if (medias[k].ready && s.indexOf(medias[k].file) !== -1 && !(imgs[i].parentElement && imgs[i].parentElement.querySelector('canvas.dc-preview-canvas'))) missing++; } }
        /* prima ridisegna subito le tele già pronte (evita il lampo delle gambe nere originali), poi ricalcola i colori */
        if (missing > 0 && touched) { medias.forEach(function (m) { if (m.ready && m.key) blit(m); }); update(); }
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
